import { render, staticRenderFns } from "./PaymentSelector.vue?vue&type=template&id=74e3a7f3"
import script from "./PaymentSelector.vue?vue&type=script&lang=ts"
export * from "./PaymentSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports